import http from '@/axios/http';

export const getAccountList = (parameters) => {
  return http.get('/api/account', parameters);
};
